import classcat from "classcat";
import React from "react";
import { useTranslation } from "react-i18next";

import { TranslationContext } from "@is/constants";

import css from "./NoResultsPlaceholder.module.css";

type Props = {
  itemsCount: number;
};

const INITIAL_OPACITY = 0.7;
const END_OPACITY = 0.2;

const NoResultsPlaceholder = ({ itemsCount }: Props) => {
  const { t } = useTranslation(TranslationContext.DeviceRegistration);
  const items = new Array(itemsCount).fill(0);

  const opacityStep = (INITIAL_OPACITY - END_OPACITY) / (itemsCount - 1);

  return (
    <>
      {items.map((_, index) => (
        <div
          key={index}
          style={{ opacity: INITIAL_OPACITY - index * opacityStep }}
          className={css.container}
        />
      ))}
      <div className={classcat(["text-body-xl", css.textContainer])}>
        {t(
          "Sorry, no results matched your search. Try again with different keywords or filters!"
        )}
      </div>
    </>
  );
};

export default NoResultsPlaceholder;
